import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-trial-ai-tariff-infos',
  templateUrl: './subscription-trial-ai-tariff-infos.component.html',
  standalone: false
})
export class SubscriptionTrialAiTariffInfosComponent {

}
